'use client';

import { c as _c } from "react/compiler-runtime";
import { CurrentQuestion } from './CurrentQuestion';
import { useCurrentQuestion } from './legalFormHooks';
import { AnsweredQuestions } from './AnsweredQuestions';
import { useId } from 'react';
export const Questions = () => {
  const $ = _c(3);
  const currentQuestionTitleId = useId();
  const question = useCurrentQuestion();
  let t0;
  if ($[0] !== currentQuestionTitleId || $[1] !== question) {
    t0 = <div>{question != null ? <CurrentQuestion key={question.id} question={question} id={currentQuestionTitleId} /> : <AnsweredQuestions />}</div>;
    $[0] = currentQuestionTitleId;
    $[1] = question;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};